import FreespinsMediator from "mediators/freespins-mediator";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import gameState from "slotworks/model/game-state";
import smartButton from "slotworks/smart-button/smart-button";
import FreespinIdle from "slotworks/state-machine/standard/states/freespin-idle";
import State from "slotworks/state-machine/states/state";
import Timer from "slotworks/utils/timer";

export default class HarleyFreespinIdle extends State {

    public static WAIT: number = 0;

    private waitTimer: number;

    public onEnter() {

        smartButton.refresh();

        new FreespinsMediator().start().execute();

        regulation.updateNetPosition(gameState.getNetPosition());
        
        if (FreespinIdle.WAIT > 0) {
            this.waitTimer = Timer.setTimeout(() => this.complete(), FreespinIdle.WAIT);
        } else {
            this.complete();
        }
    }

    public onSkip() {
        Timer.clearTimeout(this.waitTimer);

        this.skip();
    }

    public onExit() {
        StaticSymbolsCommand().execute();

        super.onExit();
    }

}